export enum Social {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
}
